import React from 'react'
import PropTypes from 'prop-types'
import { ListGroup } from 'react-bootstrap'
import ListItem from '../listItem'

const List3 = (props) => {
  return (
    <ListGroup className={props.className} id={props.id}>
      {props.children}
    </ListGroup>
  )
}

List3.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string
}

List3.defaultProps = {}

List3.Item = ListItem

export default List3
